import { render, staticRenderFns } from "./UserAccessManagement.vue?vue&type=template&id=1d65988d&scoped=true&"
import script from "./UserAccessManagement.vue?vue&type=script&lang=ts&"
export * from "./UserAccessManagement.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d65988d",
  null
  
)

export default component.exports